import React, {Component} from 'react'
import {Link} from 'react-router'
import {Col, Row, Image, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {IoRibbonB, FaHeartbeat} from '../ReactIcons/icons'

import '../../SearchResult/Layout/SearchResult.css'

const defaultHorseImage = `${window.location.protocol}//${window.location.host}/horse.jpg`
const coverMale = `${window.location.protocol}//${window.location.host}/cover-male.jpg`
const coverFemale = `${window.location.protocol}//${window.location.host}/cover-female.jpg`

class HorseBox extends Component {
  render () {
    const tooltipGoodStrain = (
      <Tooltip id="tooltip">تیره‌ی همسان</Tooltip>
    )
    const {horse} = this.props
    return (
      <Col key={horse.id} xs={12} sm={6} md={4} lg={3} className="HorseBox">
        <Row>
          <OverlayTrigger placement="left" overlay={<Tooltip id="horse-like-counticon">تعداد لایک‌ها</Tooltip>} >
            <FaHeartbeat className="CoverLike" />
          </OverlayTrigger>
          <span className="CoverLikeText">{horse.likeCount}</span>
          {(horse.isGoodStrain) ? <OverlayTrigger placement="right" overlay={tooltipGoodStrain}><IoRibbonB className="CoverGoodStrain" title="Good Strain" /></OverlayTrigger> : null}
          <Image src={(horse.genderType === 'male') ? coverMale : coverFemale} alt="" className="Cover" />
        </Row>
        <Row>
          <Col xs={6} xsOffset={3} >
            <Link to={`/horse/${horse.key}`}><Image src={(horse.avatar) ? horse.avatar : defaultHorseImage} alt="" className="Avatar" /></Link>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <h3 className="Name"><Link to={`/horse/${horse.key}`}>{horse.name}</Link></h3>
            <h4 className="Strain">{horse.strain !== null ? horse.strain : '(نامشخص)'}</h4>
          </Col>
        </Row>
        <Row className="HorseParent">
          <Col xs={6} className="Sire">
            {horse.sire.key !== null ? <Link to={`/horse/${horse.sire.key}`}><Image src={(horse.sire.avatar) ? horse.sire.avatar : defaultHorseImage} alt="" className="Avatar" /></Link> : <Image src={defaultHorseImage} alt="" className="Avatar" />}
            <h5 className="Name"><Link to={`/horse/${horse.sire.key}`}>{horse.sire.name}</Link></h5>
            <h6 className="Strain">{horse.sire.strain !== null ? horse.sire.strain : '(نامشخص)'}</h6>
          </Col>
          <Col xs={6} className="Dam">
            {horse.dam.key !== null ? <Link to={`/horse/${horse.dam.key}`}><Image src={(horse.dam.avatar) ? horse.dam.avatar : defaultHorseImage} alt="" className="Avatar" /></Link> : <Image src={defaultHorseImage} alt="" className="Avatar" />}
            <h5 className="Name"><Link to={`/horse/${horse.dam.key}`}>{horse.dam.name}</Link></h5>
            <h6 className="Strain">{horse.dam.strain !== null ? horse.dam.strain : '(نامشخص)'}</h6>
          </Col>
        </Row>
        <Row className="Footer">
          <Link className="MoreInfo" to={`/horse/${horse.key}`}>اطلاعات بیشتر</Link>
        </Row>
      </Col>
    )
  }
}

export default HorseBox



// WEBPACK FOOTER //
// ./src/components/Common/HorseBox/HorseBox.js